import React from "react";
import PropTypes from "prop-types";
import SearchUserList from "../searchUserList/SearchUserList";
import "./SearchTabContent.scss";
import SearchMultiList from "../searchMultiList/SearchMultiList";

/**
 * Search Tab Content component to display brand or member list based on active tab
 * @param activeTab - Current active tab ('BRAND' or 'SELLER')
 * @param hostname - Hostname for API calls
 * @param userAgent - User agent for API calls
 * @param handleOnBrandClick
 * @param handleOnQueryClick
 * @returns {JSX.Element}
 * @constructor
 */
export default function SearchTabContent({
  activeTab,
  hostname,
  userAgent,
  handleOnBrandClick,
  handleOnQueryClick,
}) {
  return (
    <div className="SearchTabContent">
      {activeTab === "BRAND" && (
        <SearchMultiList
          hostname={hostname}
          userAgent={userAgent}
          handleOnBrandClick={handleOnBrandClick}
          handleOnQueryClick={handleOnQueryClick}
        />
      )}
      {activeTab === "SELLER" && (
        <SearchUserList hostname={hostname} userAgent={userAgent} />
      )}
    </div>
  );
}

SearchTabContent.propTypes = {
  activeTab: PropTypes.oneOf(["BRAND", "SELLER"]).isRequired,
  hostname: PropTypes.string.isRequired,
  userAgent: PropTypes.string.isRequired,
  handleOnBrandClick: PropTypes.func,
  handleOnQueryClick: PropTypes.func,
};
